import { useFormikContext } from 'formik'
import { t } from 'i18next'
import { FC } from 'react'

import { getCurrencySymbol } from '@utils/transaction.utils'

import type { WalletDepositFormValues } from '@model/WalletDepositFormValues'
import { CurrencyType } from '@model/WalletDto'

import { createFormCurrencyAmountField } from '@global/formField/CurrencyAmountRateField'

const FormCurrencyAmountField = createFormCurrencyAmountField<WalletDepositFormValues>()

export const MAX_ALLOWED_AMOUNT = 1_000_000_000_000_000

interface CurrencyAmountFieldProps {
  showLabel?: boolean
  placeholder?: string
  fullWidth?: boolean
  className?: string
  autoFocus?: boolean
  onBlur?: () => void
}

export const CurrencyAmountField: FC<CurrencyAmountFieldProps> = ({
  showLabel = true,
  placeholder,
  fullWidth = true,
  className,
  autoFocus = false,
  onBlur,
}) => {
  const { values } = useFormikContext<WalletDepositFormValues>()

  const fromCurrency = values.wallet.currency.id
  const toCurrency = values.paymentProvider.currency.id
  const amountCurrencySymbol = getCurrencySymbol((toCurrency || fromCurrency) as CurrencyType)

  return (
    <FormCurrencyAmountField
      name='amount'
      label={showLabel ? t('Wallet.Amount') : undefined}
      placeholder={placeholder}
      fromCurrency={toCurrency}
      toCurrency={fromCurrency}
      onBlur={onBlur}
      leftText={amountCurrencySymbol}
      max={MAX_ALLOWED_AMOUNT}
      fullWidth={fullWidth}
      required
      className={className}
      autoFocus={autoFocus}
    />
  )
}
